<template>
  <path
    d="M6 17.0002H18C18.55 17.0002 19 17.4502 19 18.0002C19 18.5502 18.55 19.0002 18 19.0002H6C5.45 19.0002 5 18.5502 5 18.0002C5 17.4502 5.45 17.0002 6 17.0002ZM11.17 6.25019L6.37 13.4502C5.92 14.1102 6.4 15.0002 7.2 15.0002H16.8C17.6 15.0002 18.08 14.1102 17.63 13.4502L12.83 6.25019C12.44 5.65019 11.56 5.65019 11.17 6.25019Z"
  />
</template>
